module.exports = __webpack_public_path__ + "img/Managers.2a8f1447.png";